/* global globalThis */

export const getFlags = store => {
  const data = store.getItem('flags');
  try {
    return JSON.parse(data) || {};
  } catch (e) {
    return {};
  }
};

/**
 * Get the value of the feature flag, try to use the debugModel first
 *
 * @param {string} flagName
 * @returns {boolean}
 */
export const getFeatureFlag = (flagName) => {
  const debugModel = globalThis.__sbgModules?._appContext?.debugModel ?? {};
  if (typeof debugModel.getFeatureFlag === 'function') {
    return debugModel.getFeatureFlag(flagName);
  }

  // fall back behavior in case the debugModel has not yet been loaded
  const config = window.frontendStoryLineConfig;
  if (!config || Object.keys(config).length === 0) {
    return false;
  }
  const env = config.activeThru;
  const overrideFlags = getFlags(localStorage);
  const flags = {...config[env], ...overrideFlags};
  return Boolean(flags[flagName]);
};
